import React from "react";
import useModal from "../../../hooks/useModal";
import trash from "../../../assets/icons/trash.svg";
import archive from "../../../assets/icons/archive.svg";
import ArchiveDeleteFile from "../Modales/ArchiveDeleteFile";
import { useMissionStore } from "../../../stores/admin/mission";
import {
  dateFormat,
  splitMissionName,
} from "../../../services/Utils/functionService";
import DeleteMission from "../Modales/DeleteMission";

const MissionsAdminTable = () => {
  // Store
  const { missions, editingMissionId } = useMissionStore();

  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();

  return (
    <div className="w-full h-full">
      {isModalOpen ? modalContent : null}
      
      {/* En-têtes de colonnes avec design moderne */}
      <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 sticky top-0">
        <div className="grid grid-cols-6 gap-4 text-sm font-semibold text-gray-700">
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              Service
            </span>
          </div>
          <div className="col-span-2 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Nom de la mission
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Responsable
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Date de fin
            </span>
          </div>
          <div className="col-span-1 flex items-center justify-center">
            <span className="text-center">Actions</span>
          </div>
        </div>
      </div>

      {/* Corps de la table avec design moderne */}
      <div className="w-full overflow-y-auto max-h-[calc(90vh-20rem)]">
        {missions?.length === 0 || missions === undefined ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucune mission trouvée</h3>
            <p className="text-gray-500">Aucune mission n'a été trouvée.</p>
          </div>
        ) : (
          missions?.map((mission: any) => (
            <div
              key={mission?.id}
              className={`w-full transition-all duration-200 border-b border-gray-100 grid grid-cols-6 gap-4 px-6 py-4 ${
                editingMissionId === mission?.id
                  ? "bg-blue-50 border-l-4 border-l-blue-500"
                  : mission?.closed === 1
                  ? "bg-gray-50 text-gray-500"
                  : "hover:bg-blue-50"
              }`}
            >
              {/* Service */}
              <div className="col-span-1 flex items-center">
                <div className={`font-medium ${mission?.closed === 1 ? 'text-gray-500' : 'text-gray-900'}`}>
                  {mission?.CategoryMission?.name || '-'}
                </div>
              </div>
              
              {/* Nom de la mission */}
              <div className="col-span-2 flex items-center">
                <div className={`${mission?.closed === 1 ? 'text-gray-500' : 'text-gray-700'}`}>
                  {splitMissionName(mission?.name) || '-'}
                </div>
                {editingMissionId === mission?.id && (
                  <div className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-200 text-blue-700">
                    En cours d'édition
                  </div>
                )}
              </div>
              
              {/* Responsable */}
              <div className="col-span-1 flex items-center">
                <div className={`${mission?.closed === 1 ? 'text-gray-500' : 'text-gray-700'}`}>
                  {mission?.UserToMissions[0]?.User?.fullName || '-'}
                </div>
              </div>
              
              {/* Date de fin */}
              <div className="col-span-1 flex items-center">
                {mission?.dueDate ? (
                  <div className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                    mission?.closed === 1 
                      ? 'bg-gray-200 text-gray-600' 
                      : 'bg-orange-100 text-orange-800'
                  }`}>
                    {dateFormat(mission?.dueDate)}
                  </div>
                ) : (
                  <div className="text-gray-400 text-sm">-</div>
                )}
              </div>
              
              {/* Actions */}
              <div className="col-span-1 flex items-center justify-center gap-2">
                {/* Bouton Archiver/Désarchiver */}
                <button
                  className={`p-2 rounded-lg transition-colors duration-200 cursor-pointer group ${
                    mission?.closed === 1
                      ? 'bg-green-100 hover:bg-green-200'
                      : 'bg-yellow-100 hover:bg-yellow-200'
                  }`}
                  onClick={() =>
                    openModal(
                      <ArchiveDeleteFile
                        closed={mission?.closed}
                        id={mission?.id}
                        closeModal={closeModal}
                        idCustomer={mission?.Customer?.id}
                      />
                    )
                  }
                  title={mission?.closed === 1 ? "Désarchiver" : "Archiver"}
                >
                  <img 
                    src={archive} 
                    alt={mission?.closed === 1 ? "désarchiver" : "archiver"} 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                  />
                </button>
                
                {/* Bouton Supprimer */}
                <button
                  className={`p-2 rounded-lg transition-colors duration-200 cursor-pointer group ${
                    mission?.closed === 1
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'bg-red-100 hover:bg-red-200'
                  }`}
                  onClick={() => {
                    if (mission?.closed === 1) {
                      openModal(
                        <DeleteMission
                          id={mission?.id}
                          closeModal={closeModal}
                        />
                      );
                    }
                  }}
                  disabled={mission?.closed !== 1}
                  title={mission?.closed !== 1 ? "Impossible de supprimer une mission archivée" : "Supprimer"}
                >
                  <img 
                    src={trash} 
                    alt="supprimer" 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                  />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(MissionsAdminTable);
